import { apiRequest } from './authService';

/**
 * Safe (Cofre) service. A running vault balance per currency (USD/SRD/EUR) that
 * carries over day to day. Transactions add or subtract.
 */

export async function getDay(date) {
  try {
    const response = await apiRequest('safe/day', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to load day' };
  } catch (e) {
    console.error('safe getDay error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function getDayVersion(date) {
  try {
    const response = await apiRequest('safe/day-version', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch (e) {
    return { success: false };
  }
}

export async function addTransaction(date, type, description, { usd, srd, eur } = {}) {
  try {
    const response = await apiRequest('safe/add-transaction', {
      method: 'POST',
      body: JSON.stringify({
        date, type, description,
        amount_usd: usd, amount_srd: srd, amount_eur: eur
      })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to add transaction' };
  } catch (e) {
    console.error('safe addTransaction error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function updateTransaction(id, fields) {
  try {
    const body = { id };
    if (fields.type !== undefined) body.type = fields.type;
    if (fields.description !== undefined) body.description = fields.description;
    if (fields.usd !== undefined) body.amount_usd = fields.usd;
    if (fields.srd !== undefined) body.amount_srd = fields.srd;
    if (fields.eur !== undefined) body.amount_eur = fields.eur;

    const response = await apiRequest('safe/update-transaction', {
      method: 'POST',
      body: JSON.stringify(body)
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to update transaction' };
  } catch (e) {
    console.error('safe updateTransaction error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

/** Get the day's saved bill count (if any) + the current running saldo + denominations. */
export async function getClosing(date) {
  try {
    const response = await apiRequest('safe/get-closing', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to load count' };
  } catch (e) {
    console.error('safe getClosing error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

/** Save (upsert) the day's bill count. */
export async function saveClosing(date, counts) {
  try {
    const response = await apiRequest('safe/save-closing', {
      method: 'POST',
      body: JSON.stringify({ date, counts })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to save count' };
  } catch (e) {
    console.error('safe saveClosing error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function deleteTransaction(id) {
  try {
    const response = await apiRequest('safe/delete-transaction', {
      method: 'POST',
      body: JSON.stringify({ id })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to delete transaction' };
  } catch (e) {
    console.error('safe deleteTransaction error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}
